module.exports = __webpack_public_path__ + "static/grain-33855b266ad430e5f3e6ed4d33968efc.png";